<template>
  <div class="flex h-fit w-full relative">
    <div v-if="showTooltip" class="fixed w-full h-full z-50 bg-transparent top-0 left-0 mb-[30px]"
         @click="handleClickOutsideTooltip"/>
    <div v-if="showTooltip"
         :style="tooltipStyle"
         class="tooltip w-[276px] h-fit absolute z-[100] flex flex-col bg-white rounded border border-grays-400 shadow-interface">
      <div class="w-full h-fit flex flex-col pt-[20px] pb-[11px] px-[20px]">
        <div class="w-full flex flex-row items-center mb-[20px]">
          <div
              class="h-[36px] w-[36px] rounded-full bg-complementary-600 flex-none ml-[8px] flex items-center justify-center p-[9px]">
            <icon-mishnat/>
          </div>
          <div class="w-full flex flex-col">
            <h2 class="font-bold text-2xl text-complementary-900">{{ clickedEvent.title }}</h2>
            <p class="font-regular text-sm text-complementary-900 mt-[-5px]">{{
                clickedEvent.extendedProps.subtitle
              }}</p>
          </div>
        </div>
        <div class="w-full flex flex-col">
          <p class="font-medium text-sm text-grays-600 mb-[8px]">Open Day</p>
          <div class="flex flex-row items-center gap-[4px]">
            <span class="material-symbols-rounded text-grays-900 text-[16px] leading-[16px] flex">schedule</span>
            <!-- <p class="text-base font-regular text-grays-900">{{moment(upcomingSale.supply_begin).format('dddd')}} {{jDate(upcomingSale.supply_begin)}} {{moment(upcomingSale.supply_begin).format('DD/MM/Y')}} </p> -->
            <p class="text-base font-regular text-grays-900">יום רביעי’, כ”ו כסליו 19/12/22 </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col max-h-[226px] custom-scroll-bar overflow-y-auto border-t border-grays-400">
        <div
            class="w-ful flex flex-col px-[20px]"
        >
          <div
              class="flex flex-row-reverse items-center justify-end gap-[8px] py-[16px]"
          >

            <p class="text-lg text-primary-700 font-medium">קטגוריות במכירה</p>
          </div>
          <div class="pb-[27px]">
            <categories-menu-view :categoriesList="categories"/>
          </div>
        </div>
      </div>
    </div>
    <FullCalendar
        ref="calendar"
        :options='calendarOptions'
        class='demo-app-calendar w-full bg-white border border-grays-400 rounded pt-[25px] overflow-hidden'
    >
      <template v-slot:eventContent='arg'>
        <active-sale-event
            v-if="arg.isEnd && arg.event.extendedProps.status === 'active'"
            :isSmall="arg.event.extendedProps.isSmall"
            :subtitle="arg.event.extendedProps.subtitle"
            :title="arg.event.title"
        />
        <done-sale-event
            v-if="arg.isEnd && arg.event.extendedProps.status === 'done'"
            :isSmall="arg.event.extendedProps.isSmall"
            :subtitle="arg.event.extendedProps.subtitle"
            :title="arg.event.title"
        />
        <coming-sale-event
            v-if="arg.isEnd && arg.event.extendedProps.status === 'coming'"
            :isSmall="arg.event.extendedProps.isSmall"
            :subtitle="arg.event.extendedProps.subtitle"
            :title="arg.event.title"
        />
        <!-- placeholder for empty lines -->
        <div
            v-if="!arg.isEnd"
            :class="[
					'w-full h-[96px] opacity-0',
					arg.event.extendedProps.isSmall ? '!h-[21px]' : '',
				]"
        />
      </template>
    </FullCalendar>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
// import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import {INITIAL_EVENTS} from '../../helpers/event-utils'
import IconMishnat from "@/components/Global/IconMishnat.vue";
import CategoriesMenuView from "@/components/Global/CategoriesMenuView.vue";
import ActiveSaleEvent from "@/components/Calendar/ActiveSaleEvent.vue";
import DoneSaleEvent from "@/components/Calendar/DoneSaleEvent.vue";
import ComingSaleEvent from "@/components/Calendar/ComingSaleEvent.vue";


export default {
  name: "calendar",
  components: {ComingSaleEvent, DoneSaleEvent, ActiveSaleEvent, CategoriesMenuView, IconMishnat, FullCalendar},
  data() {
    return {
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next'
        },
        initialView: 'dayGridMonth',
        initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: false,
        selectable: false,
        dayMaxEvents: false,
        weekends: true,
        contentHeight: 1018,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        // eventsSet: this.handleEvents(INITIAL_EVENTS),
        firstDay: 1,
        locale: 'he',
      },
      showTooltip: false,
      tooltipStyle: {
        top: "0px",
        left: "0px",
      },
      clickedEvent: null,
      categories: [
        "ירקות",
        "פירות",
        "עלים וקצוצים",
        "מאפים",
        "ביצים",
        "מוצרי הקפאה",
        "מוצרי יסוד",
        "קטניות ושימורים",
        "דגנים וממתקים",
        "אגוזים ותבלינים",
        "יין ומיץ ענבים",
        "מוצרי חלב ושוקולד",
        "קפואים",
        "טיפוח ונקיון",
        "חד פעמי",
        "קיץ",
        "ביגוד",
      ],
    }
  },
  methods: {
    handleClickOutsideTooltip(event) {
      const tooltip = document.querySelector('.tooltip');
      const isClickInsideTooltip = tooltip.contains(event.target);
      if (!isClickInsideTooltip) {
        this.showTooltip = false;
      }
    },
    handleEventClick(clickInfo) {
      this.clickedEvent = clickInfo.event;
      this.showTooltip = true;

      // Get the calendar's DOM element using the ref
      const calendarElement = this.$refs.calendar.$el;

      // Calculate the position relative to the calendar element
      const top = clickInfo.jsEvent.clientY - calendarElement.getBoundingClientRect().top;
      const left = clickInfo.jsEvent.clientX - calendarElement.getBoundingClientRect().left;

      this.tooltipStyle.top = `${top}px`;
      this.tooltipStyle.left = `${left}px`;
    },
    handleEvents(events) {
      this.currentEvents = events
    },
  }
}
</script>

<style lang="scss">

.fc-header-toolbar {
  margin: auto;
  margin-bottom: 18px;
  width: fit-content;
}

.fc-toolbar-title {
  font-size: 24px !important;
  color: #707070;
  margin: 0 4px !important;
}

.fc-button {
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  color: #707070 !important;
  outline: none !important;
  box-shadow: none !important;
}

.fc-button:focus {
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  color: #707070 !important;
  outline: none !important;
}

.fc-scrollgrid {
  /* border: 0 !important; */
  border-top: 0px !important;
}

th .fc-scrollgrid-sync-inner {
  /* position: relative;
  left: 1px; */
  /* background-color: white; */
}

.fc th {
  /* width: calc(100% + 2px) !important; */
  left: -1px;
  position: relative;
  background-color: white;
  border-right: 0px !important;
}

.fc .fc-scrollgrid-liquid {
  border: 0;
}

.fc .fc-scrollgrid-section-liquid > td {
  position: relative;
  bottom: -1px;
}

.fc-theme-standard td, .fc-theme-standard th {
  border-right: 0;
}

.fc .fc-col-header-cell-cushion {
  color: #707070;
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 13px;
}

.fc .fc-daygrid-day-top {
  /* background-color: #3F238B; */
  width: 31px;
  height: 31px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 19px auto 12px auto;
}

.fc .fc-daygrid-day-number {
  text-align: center;
  color: #707070;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 0;
}

.fc-day-today {
  background: transparent !important;
}

.fc-day-today .fc-daygrid-day-number {
  color: white;
}

.fc-day-today .fc-daygrid-day-top {
  background-color: #3F238B;
}

.fc-h-event {
  // background-color: #EAE7F9;
  border: 0;
  border-radius: 0;
  margin: 0;
  border-right: 2px solid #3F238B;
}

.fc-daygrid-event-harness {
  .fc-event {
    margin: 0 !important;
    margin-top: 4px !important;
  }
}

.fc-event-main {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.m-event {
  padding: 2px 11px 2px 0;
  display: flex;

  .title {
    font-size: 12px;
    color: #3F238B;
    font-weight: 600;
    margin-right: 8px;

    span {
      font-weight: 400;
      margin-right: 4px;
    }
  }

  .circle {
    height: 17px;
    width: 17px;
    background-color: #61EAE8;
    border-radius: 100px;
    padding: 4px;
  }
}

.m-event:hover {
  .h-event {
    opacity: 1 !important;
  }
}

.m-event-hide {
  opacity: 0;
}

.h-event {
  position: absolute;
  width: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: right;
  padding: 14px 20px 9px 20px;
  border-right: 2px solid #3F238B;
  background-color: #EAE7F9;
  right: -2px;
  z-index: 999;
  bottom: 30px;
  opacity: 0;
}

.fc-daygrid-day-frame {
  height: 162px !important;
}

</style>